import { useEffect, useState } from 'react';
import io from 'socket.io-client';
import config from '../config/api';
import toast from 'react-hot-toast';

export function useWebSocket() {
  const [socket, setSocket] = useState(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    const newSocket = io(config.wsUrl);

    newSocket.on('connect', () => {
      setConnected(true);
      toast.success('Live updates aktiveret');
    });

    newSocket.on('disconnect', () => {
      setConnected(false);
      toast.error('Live updates afbrudt');
    });

    newSocket.on('production_registered', (data) => {
      toast.success(`Ny produktion registreret: ${data.quantity} enheder`);
      // Trigger re-fetch af data
      window.dispatchEvent(new CustomEvent('refetchData', { detail: 'production' }));
    });

    newSocket.on('curing_status_updated', (data) => {
      if (data.count > 0) {
        toast.success(`${data.count} batches er nu klar til salg`);
        window.dispatchEvent(new CustomEvent('refetchData', { detail: 'production' }));
      }
    });

    setSocket(newSocket);

    return () => newSocket.close();
  }, []);

  return { socket, connected };
}